/**
 * Returns localized plan text (name, description, features, labels) from API response.
 * Plans include `en` and `es` objects; falls back to `en` then legacy top-level fields.
 */
export const getPlanLocalized = (plan, lang = "en") => {
  if (!plan) {
    return {
      name: "",
      description: "",
      features: [],
      billing_cycle_label: "",
      duration_type_label: "",
    };
  }

  const locale = lang === "es" ? "es" : "en";
  const localized = plan[locale] || plan.en || {};

  return {
    name: localized.name || plan.name || "",
    description: localized.description || plan.description || "",
    features: Array.isArray(localized.features)
      ? localized.features
      : Array.isArray(plan.features)
        ? plan.features
        : [],
    billing_cycle_label: localized.billing_cycle_label || "",
    duration_type_label: localized.duration_type_label || "",
  };
};
